import { render } from "./ConsumablesTable.vue?vue&type=template&id=0908ac61&scoped=true"
import script from "./ConsumablesTable.vue?vue&type=script&lang=js"
export * from "./ConsumablesTable.vue?vue&type=script&lang=js"

import "./ConsumablesTable.vue?vue&type=style&index=0&id=0908ac61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0908ac61"]])

export default __exports__